import { BillingAddress } from './model/billing-address';
import { BillingAddressesWithAccountingEmail } from './model/billing-addresses-with-accounting-email';
import { ContractOrProductWithPrice } from './model/contract-or-product-with-price';

export class ResetBillingAddresses {
  static readonly type = '[MarketplaceBillingInformation] Reset billing addresses';
}

export class SetBillingAddresses {
  static readonly type = '[MarketplaceBillingInformation] Set billing addresses';
  constructor(public billingAddressesWithAccountingEmail: BillingAddressesWithAccountingEmail) {}
}

export class FetchBillingAddresses {
  static readonly type = '[MarketplaceBillingInformation] Fetch billing addresses';
  constructor(public contractId: string | null) {}
}

export class CreateBillingAddress {
  static readonly type = '[MarketplaceBillingInformation] Create new billing address';
  constructor(public billingAddress: BillingAddress) {}
}

export class UpdateBillingAddress {
  static readonly type = '[MarketplaceBillingInformation] Update existing billing address';
  constructor(public billingAddress: BillingAddress, public overrideSubscription?: ContractOrProductWithPrice) {}
}

export class DeleteBillingAddress {
  static readonly type = '[MarketplaceBillingInformation] Delete existing billing address';
  constructor(public billingAddressId: number) {}
}

export class BillingAddressCreated {
  static readonly type = '[MarketplaceBillingInformation] Billing address created';
  constructor(public billingAddress: BillingAddress) {}
}

export class BillingAddressUpdated {
  static readonly type = '[MarketplaceBillingInformation] Billing address updated';
  constructor(public original: BillingAddress, public update: BillingAddress) {}
}

export class BillingAddressDeleted {
  static readonly type = '[MarketplaceBillingInformation] Billing address deleted';
  constructor(public billingAddress: BillingAddress) {}
}
